import { navigate } from 'gatsby';
import { useLocation } from '@reach/router';

type Callback = (params: URLSearchParams) => URLSearchParams;
type UseSearchParams = () => [URLSearchParams, (callback: Callback) => void];

export const useSearchParams: UseSearchParams = () => {
    const { pathname, search, state } = useLocation();
    const params = new URLSearchParams(search);

    const setParams = (callback: Callback) => {
        const nextParams = callback(params);
        const search = nextParams.toString();
        const path = search ? `${pathname}?${search}` : pathname;

        navigate(path, { state: state as Record<string, unknown>, replace: true });
    };

    return [params, setParams];
};
